// extracted by mini-css-extract-plugin
module.exports = {"section":"SectionWhatIsSCOrder_section__Pru8f","bg":"SectionWhatIsSCOrder_bg__Am1El","container":"SectionWhatIsSCOrder_container__dFaeQ"};